import { Route } from 'vue-router'
import router from './index'
import store from '@/apps/open/store'
import { goLogin } from '@/apps/open/utils'
import { EDeveloperStatus } from '../store/modules/user/types'

const isPrivate = store.getters['isPrivate']

router.beforeEach(async (to: Route, form: Route, next: Function) => {
  if (isPrivate && !store.getters['priConfig']) {
    await store.dispatch('Plussvr/GET_PRIVATE_CONFIG')
  }
  if (!store.state.User.userInfo) {
    try {
      const res = await store.dispatch('User/GET_USER_INFO')
      if (res.userid) {
        const params = {
          status: 'active',
          fields: 'name,role_id'
        }
        await store.dispatch('Plussvr/SET_INTERPRISE_INFO', params)
        store.dispatch('User/SET_DEVELOPER_LIST')
      }
    } catch (error) {
      if (to.matched.some(record => record.meta.requireAuth)) {
        next()
        goLogin()
        return
      }
    }
  }

  // 拦截非服务商路由
  if (to.fullPath.indexOf('/developer-info') === 0 ||
    to.fullPath.indexOf('/app-info') === 0 ||
    to.fullPath.indexOf('/admin-users') === 0 ||
    to.fullPath.indexOf('/weboffice') === 0 ||
    to.fullPath.indexOf('/format-conversion') === 0) {
    const curEnterprise = store.getters['User/curEnterprise']
    if (!curEnterprise || !curEnterprise.developer_id) {
      next({ name: 'home', replace: true })
      return
    }
  }

  // 申请服务商
  if (to.query.to === 'apply') {
    next({ name: 'apply-developer', replace: true })
    return
  }

  // 拦截auth只有通过企业授权能力才可
  if (to.name === 'app-auth') {
    if (!store.getters['App/authTabStatus']) {
      next({ name: form.name, replace: true })
      return
    }
  }

  // 拦截async，只有通过企业通讯录能力才可
  if (to.name === 'app-sync') {
    if (!store.getters['App/syncTabStatus']) {
      next({ name: form.name, replace: true })
      return
    }
  }

  let requireDeveloperStatus = [] as EDeveloperStatus[]
  to.matched.forEach(record => {
    if (record.meta.requireDeveloperStatus) {
      requireDeveloperStatus = record.meta.requireDeveloperStatus
    }
  })
  if (requireDeveloperStatus.length) {
    const developerStatus = store.getters['User/curEnterprise'].status

    if (!requireDeveloperStatus.includes(developerStatus)) {
      next({ name: 'home', replace: true })
      return
    }
  }

  next()
})
